import type { RenderProps } from "../../common/types";
import interoperabilityRenderer from "./interoperability";
import switchRenderer from "../../common/switch";
import datetimeRangeRenderer from "../../common/datetime-range";
import duiNitRenderer from "../../common/dui-nit";
import selectRenderer from "../../common/select";
import filteredSelectRenderer from "../../common/filtered-select";
import expedientRenderer from "../../common/expedient";
import fileRenderer from "../../common/file";
import numberRenderer from "../../common/number";
import phoneRenderer from "../../common/phone";

const renderers: Record<string, (p: RenderProps) => React.ReactNode> = {
  interoperability: interoperabilityRenderer,
  switch: switchRenderer,
  expedient: expedientRenderer,
  datetime_range: datetimeRangeRenderer,
  date_range: datetimeRangeRenderer,
  dui_nit: duiNitRenderer,
  file: fileRenderer,
  select: selectRenderer,
  filtered_select: filteredSelectRenderer,
  "filtered-list": filteredSelectRenderer,
  filtered_list: filteredSelectRenderer,
  number: numberRenderer,
  phone: phoneRenderer,
};

export default renderers;
